import { useMutationUserPreferencesUpdate } from '../../user/mutations/useMutationUserPreferencesUpdate.js';
import { useQueryUserPreferences } from '../../user/queries/useQueryUserPreferences.js';
import { LABS_FEATURES } from '../labs.config.js';
import { noop, noopAsync } from '@fabric-app/utils/guards/noop';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useFeatureGuard_fabricLabs } from '../../pricing/hooks/useFeatureGuard.js';
import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { captureException } from '@fabric-app/compat/capabilities/sentry';
import { toast } from '../../store/alerts.js';

const useLabsFeature = (feature) => {
  const fabricLabsFeatureGuard = useFeatureGuard_fabricLabs().check(void 0);
  const { track } = useAnalytics();
  const { data: userPreferences, refetch, isLoading } = useQueryUserPreferences({
    enabled: !!feature
  });
  const { mutate: updateUserPreferences } = useMutationUserPreferencesUpdate();
  const details = feature ? LABS_FEATURES[feature] : null;
  if (!feature || !fabricLabsFeatureGuard.isAllowed) {
    return {
      isEnabled: false,
      details,
      isLoading: false,
      toggleFeature: noopAsync,
      setFeature: noop
    };
  }
  const isEnabled = userPreferences?.frontend.labs?.[feature] ?? LABS_FEATURES[feature].default;
  const toggleFeature = async () => {
    try {
      const data = isLoading ? (await refetch()).data : userPreferences;
      const liveEnabled = data?.frontend.labs?.[feature] ?? LABS_FEATURES[feature].default;
      updateUserPreferences({
        data: {
          frontend: {
            labs: {
              [feature]: !liveEnabled
            }
          }
        },
        showToast: false
      }, {
        onSuccess: () => {
          track(AnalyticsEvents.FabricLabsToggleFeature, {
            feature,
            enabled: !liveEnabled
          });
        }
      });
    } catch (error) {
      toast({
        content: "Failed to toggle feature"
      });
      captureException(error);
    }
  };
  const setFeature = (enabled) => {
    updateUserPreferences({
      data: {
        frontend: {
          labs: {
            [feature]: enabled
          }
        }
      },
      showToast: false
    }, {
      onSuccess: () => {
        track(AnalyticsEvents.FabricLabsToggleFeature, {
          feature,
          enabled
        });
      }
    });
  };
  return {
    isEnabled,
    details,
    isLoading,
    toggleFeature,
    setFeature
  };
};

export { useLabsFeature };
//# sourceMappingURL=useLabsFeature.js.map
